import '../../../src/CSS/loaders.css';
function MiniLoader() {
    return (
      <div className="miniloader"></div>
    );
  }

  export default MiniLoader;